<template>
  <div>
    <div class="intro">
      <h2>OUR SALE IS</h2>
      <h2>STARTING SOON</h2>
    </div>

    <p>
      Create a Members Only account now and enjoy early sale access, exclusive
      benefits, and much more.
    </p>

    <div class="countdown-block">
      <h2>SALE STARTS IN</h2>
      <Countdown :end="endDate" theme="editorial" @ended="$emit('ended')" />
    </div>

    <div class="button-group">
      <Button theme="primary-light" width="full" @click="$emit('register')">
        Sign Up Now
      </Button>
      <Button theme="outline-light" width="full" @click="$emit('login')">
        Log In
      </Button>
    </div>
  </div>
</template>

<script>
import Button from "@/components/ButtonV3.vue";
import Countdown from "@/components/landing/Countdown.vue";

export default {
  name: "HoldingOpening",
  components: {
    Countdown,
    Button,
  },
  props: {
    endDate: {
      type: String,
      required: true,
    },
  },
  emits: ["login", "register", "ended"],
};
</script>

<style lang="scss" scoped>
h2 {
  @include editorial-headline(24px);
  text-transform: uppercase;
  margin-bottom: 0;
}

.intro {
  margin-bottom: 16px;
}

p {
  @include editorial-body(14px);
  margin: 0 auto 28px;
}

.countdown-block {
  margin-bottom: 28px;
}

.button-group {
  display: flex;
  gap: 20px;
  flex-direction: column;
}
</style>
